import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DropdownMenu from "@/components/DropdownMenu";
import People from "./People";

export default function OptionsPerfil({ info, people, menuOptions, compact = false }) {
  if (compact) {
    return (
      <DropdownMenu
        trigger={
          <button
            data-tour-id="perfil-menu-trigger"
            className="bg-transparent border border-white text-white font-semibold rounded-lg px-4 py-2 hover:bg-aw-green hover:text-aw-bluedark transition shrink-0"
          >
            <FontAwesomeIcon icon={"fa-solid fa-ellipsis"} />
          </button>
        }
        options={menuOptions}
        direction="left"
        align="end"
        classContent={menuOptions[0]?.classContent || "white"}
      />
    );
  }

  return (
      <div className="flex w-1/3 sm:w-1/2 mt-4 justify-center sm:items-center">
        <div className="flex flex-row justify-center sm:flex-col items-center w-full sm:items-end gap-2">
          {people?.seguidores && people.seguidores.length > 0 &&
            <People info={info} people={people?.seguidores} />
          }
          {/* TODO: Definir en la integración del backend que opciones colocar según el tipo de perfil */}
          <div className="flex flex-row justify-between gap-x-5 sm:gap-x-2">
            {/* {info?.myself ? (
                <></>
                ) : (
                <button className="group/followbtn bg-aw-green text-aw-bluedark font-semibold rounded-lg px-6 py-2 duration-300 hover:bg-transparent hover:text-white border border-aw-green transition">
                    <FontAwesomeIcon icon={"fa-solid fa-star"} className="sm:ml-2 text-aw-bluedark group-hover/followbtn:text-white" />
                    <span className="ml-2 text-sm">
                        Seguir
                    </span>
                </button>
                )
            } */}
            {/* <button className="bg-transparent border border-white text-white font-semibold rounded-lg px-6 py-2 hover:bg-aw-green hover:text-aw-bluedark transition">
                <FontAwesomeIcon icon={"fa-brands fa-whatsapp"} />
            </button> */}
            <DropdownMenu
              trigger={
                <button
                  data-tour-id="perfil-menu-trigger"
                  className="bg-transparent border border-white text-white font-semibold rounded-lg px-6 py-2 hover:bg-aw-green hover:text-aw-bluedark transition"
                >
                  <FontAwesomeIcon icon={"fa-solid fa-ellipsis"} />
                </button>
              }
              options={menuOptions}
              direction="left"
              align="end"
              classContent={menuOptions[0]?.classContent || "white"}
            />
          </div>
        </div>
      </div>
    
  );
}
